module.exports = __webpack_public_path__ + "static/bohater_4-e3f069bb91c72735de14eeb1b3a67e9f.png";